import { HttpService } from 'core/modules/network-service';
import { get } from 'lodash';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc MemberPrescriptionRefillsWidget defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberPrescriptionRefillsWidgetService } from 'services/memberPrescriptionRefillsWidget';
 *
 * // create service instance and send/cancel request
 * const memberPrescriptionRefillsWidgetService = new MemberPrescriptionRefillsWidgetService();
 * const result = await memberPrescriptionRefillsWidgetService.fetchData( '<user-id>' ); // fetch data
 * memberPrescriptionRefillsWidgetService.cancel(); // cancel an active request
 */
export class MemberPrescriptionRefillsWidgetService extends HttpService {

    // make request and fetch data
    async fetchComponentData( { url, data } ) {

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );
            
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ),
                data: get( response, 'body.component', {} ),
            };
            
        } catch( errResponse ) {
            return this._errorFormatter( errResponse );
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
